<template>
    <BModal
        :model-value="modal"
        scrollable
        centered
        @update:modelValue="updateModal"
        no-close-on-backdrop no-close-on-esc
    >
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Vehicle</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Name *"
                        label-for="name"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.name"
                            type="text"
                            id="name"
                            placeholder="Enter Name"
                            :class="{
                                'is-invalid':
                                    v$.form.name.$dirty &&
                                    v$.form.name.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.name.$dirty && v$.form.name.$invalid
                            "
                        >
                            {{ v$.form.name.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Plate Number *"
                        label-for="plate_number"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.plate_number"
                            type="text"
                            id="plate_number"
                            placeholder="Enter Plate Number"
                            :class="{
                                'is-invalid':
                                    v$.form.plate_number.$dirty &&
                                    v$.form.plate_number.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.plate_number.$dirty &&
                                v$.form.plate_number.$invalid
                            "
                        >
                            {{ v$.form.plate_number.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Type *"
                        label-for="type"
                        class="text-start mb-3"
                    >
                        <BFormSelect
                            id="type"
                            v-model="form.type"
                            :options="typeOptions"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    v$.form.type.$dirty &&
                                    v$.form.type.$invalid,
                            }"
                        >
                            <template #first>
                                <option disabled selected value="">
                                    Select Type
                                </option>
                            </template>
                        </BFormSelect>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.type.$dirty && v$.form.type.$invalid
                            "
                        >
                            {{ v$.form.type.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Condition *"
                        label-for="condition"
                        class="text-start mb-3"
                    >
                        <BFormSelect
                            id="condition"
                            v-model="form.condition"
                            :options="conditionOptions"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    v$.form.condition.$dirty &&
                                    v$.form.condition.$invalid,
                            }"
                        >
                            <template #first>
                                <option disabled selected value="">
                                    Select Condition
                                </option>
                            </template>
                        </BFormSelect>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.condition.$dirty &&
                                v$.form.condition.$invalid
                            "
                        >
                            {{ v$.form.condition.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Seat Capacity *"
                        label-for="seat_capacity"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.seat_capacity"
                            type="number"
                            id="seat_capacity"
                            placeholder="Enter Seat Capacity"
                            :class="{
                                'is-invalid':
                                    v$.form.seat_capacity.$dirty &&
                                    v$.form.seat_capacity.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.seat_capacity.$dirty && v$.form.seat_capacity.$invalid
                            "
                        >
                            {{ v$.form.seat_capacity.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Luggage Capacity *"
                        label-for="luggage_capacity"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.luggage_capacity"
                            type="number"
                            id="luggage_capacity"
                            placeholder="Enter Luggage Capacity"
                            :class="{
                                'is-invalid':
                                    v$.form.luggage_capacity.$dirty &&
                                    v$.form.luggage_capacity.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.luggage_capacity.$dirty &&
                                v$.form.luggage_capacity.$invalid
                            "
                        >
                            {{ v$.form.luggage_capacity.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Total KM *"
                        label-for="total_km"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.total_km"
                            type="number"
                            id="total_km"
                            placeholder="Enter Total KM"
                            :class="{
                                'is-invalid':
                                    v$.form.total_km.$dirty &&
                                    v$.form.total_km.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.total_km.$dirty &&
                                v$.form.total_km.$invalid
                            "
                        >
                            {{ v$.form.total_km.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Purchase Year"
                        label-for="purchase_year"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.purchase_year"
                            type="number"
                            id="purchase_year"
                            placeholder="Enter Purchase Year"
                            :class="{
                                'is-invalid':
                                    v$.form.purchase_year.$dirty &&
                                    v$.form.purchase_year.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.purchase_year.$dirty &&
                                v$.form.purchase_year.$invalid
                            "
                        >
                            {{
                                v$.form.purchase_year.$errors[0]?.$message
                            }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Last Date Service *"
                        label-for="last_service_date"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.last_service_date"
                            type="date"
                            id="last_service_date"
                            placeholder="Enter Total KM"
                            :class="{
                                'is-invalid':
                                    v$.form.last_service_date.$dirty &&
                                    v$.form.last_service_date.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.last_service_date.$dirty &&
                                v$.form.last_service_date.$invalid
                            "
                        >
                            {{ v$.form.last_service_date.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Tax Payment Date *"
                        label-for="tax_payment_date"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.tax_payment_date"
                            type="date"
                            id="tax_payment_date"
                            placeholder="Enter Tax Payment Date"
                            :class="{
                                'is-invalid':
                                    v$.form.tax_payment_date.$dirty &&
                                    v$.form.tax_payment_date.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.tax_payment_date.$dirty &&
                                v$.form.tax_payment_date.$invalid
                            "
                        >
                            {{ v$.form.tax_payment_date.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormSelect,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minLength } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

const typeOptions = [
    { value: "Car", text: "Car" },
    { value: "Bus", text: "Bus" },
];
const conditionOptions = [
    { value: "Good", text: "Good" },
    { value: "Damaged", text: "Damaged" },
    { value: "In Service", text: "In Service" },
];

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
});

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};

const formData = {
    name: "",
    plate_number: "",
    type: "",
    condition: "",
    total_km: "",
    last_service_date: "",
    purchase_year: "",
    seat_capacity: "",
    luggage_capacity: "",
    tax_payment_date: "",
};

const form = reactive({ ...formData });

// Init data jika update
// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        // jika props.selectedData != null (action edit)
        if (newData && Object.keys(newData).length > 0) {
            Object.assign(form, { ...newData });
        } else {
            Object.assign(form, { ...formData });
        }
    },
    { immediate: true }
);

const rules = {
    form: {
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3 characters",
                minLength(3)
            ),
        },
        plate_number: {
            required: helpers.withMessage("Plate number is required", required),
            minLength: helpers.withMessage(
                "Plate number must be at least 3 characters",
                minLength(3)
            ),
        },
        type: {
            required: helpers.withMessage("Type is required", required),
        },
        condition: {
            required: helpers.withMessage("Condition is required", required),
        },
        total_km: {
            required: helpers.withMessage("Total KM is required", required),
        },
        last_service_date: {
            required: helpers.withMessage(
                "Last service date is required",
                required
            ),
        },
        seat_capacity: {
            required: helpers.withMessage("Seat capacity is required", required),
        },
        luggage_capacity: {
            required: helpers.withMessage("Luggage capacity is required", required),
        },
        tax_payment_date: {
            required: helpers.withMessage("Tax payment date is required", required),
        },
        purchase_year: {},
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.uuid ? update() : create();
};

const create = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/vehicle/add`,
                {
                    name: form.name,
                    plate_number: form.plate_number,
                    type: form.type,
                    condition: form.condition,
                    total_km: form.total_km,
                    last_service_date: form.last_service_date,
                    purchase_year: form.purchase_year,
                    seat_capacity: form.seat_capacity,
                    luggage_capacity: form.luggage_capacity,
                    tax_payment_date: form.tax_payment_date,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/vehicle/edit/${props.selectedData.uuid}`,
                {
                    name: form.name,
                    plate_number: form.plate_number,
                    type: form.type,
                    condition: form.condition,
                    total_km: form.total_km,
                    last_service_date: form.last_service_date,
                    purchase_year: form.purchase_year,
                    seat_capacity: form.seat_capacity,
                    luggage_capacity: form.luggage_capacity,
                    tax_payment_date: form.tax_payment_date,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};
</script>
